import React from "react";
import { Skeleton, Tag, Timeline, Typography } from "antd";
import { Flex } from "css/styles";
import { InventoryTransfer } from "../../../api/transfer";
import { generateSerial, statusColor } from "../InventoryTransferIndexPage/helper";
import { startCase, upperCase } from "lodash-es";
import { Card } from "./styles";
import moment from "moment";
import * as S from "./styles";
import { Facility } from "../../../api/common//facility";
import { useFacilityLookup } from "hooks/api/common/useFacilityIndex";

const { Text, Title } = Typography;

export const TransferDetails: React.FC<{ transfer?: InventoryTransfer; loading: boolean }> = ({
  transfer,
  loading,
}) => {
  const facilityLookup = useFacilityLookup();

  const getFacilityAddress = (name: Facility["name"]) => {
    const facility = facilityLookup[name];
    if (!facility?.address) return;
    return `${facility.address.city}, ${facility.address.province}`;
  };

  const renderValue = (cb: (transfer: InventoryTransfer) => React.ReactNode) => {
    if (!transfer) return <Skeleton.Input active={loading} />;
    return cb(transfer);
  };

  return (
    <S.Container direction="vertical">
      <Title level={5}>Transfer Details</Title>
      <Card size="small" bordered>
        <S.TimelineContainer className="padded" align="start" justify="space-between">
          <Timeline>
            <Timeline.Item>
              <Flex>
                <Text type="secondary">Origin</Text>
                <Text>
                  {renderValue((t) => `${upperCase(t.from_facility)} / ${getFacilityAddress(t.from_facility)}`)}
                </Text>
              </Flex>
            </Timeline.Item>
            <Timeline.Item>
              <Flex>
                <Text type="secondary">Destination</Text>
                <Text>
                  <Text>
                    {renderValue((t) => `${upperCase(t.to_facility)} / ${getFacilityAddress(t.to_facility)}`)}
                  </Text>
                </Text>
              </Flex>
            </Timeline.Item>
          </Timeline>
        </S.TimelineContainer>
        <Flex className="padded" justify="space-between">
          <Text type="secondary">Transfer ID</Text>
          <Text>{renderValue((t) => generateSerial(t.id.toString()))}</Text>
        </Flex>
        <Flex className="padded" justify="space-between">
          <Text type="secondary">Transfer Status</Text>
          <Text>
            {renderValue((t) => (
              <Tag color={statusColor[t.status]}>{startCase(t.status)}</Tag>
            ))}
          </Text>
        </Flex>
        <Flex className="padded" justify="space-between">
          <Text type="secondary">Created Date</Text>
          <Text>{renderValue((t) => moment(t.created_at).format("LLL"))}</Text>
        </Flex>
      </Card>
    </S.Container>
  );
};
